import axios from 'axios'

import config from '../config'

export const REQUEST_TESTIMONIALS = 'REQUEST_TESTIMONIALS'
export const RECEIVE_TESTIMONIALS = 'RECEIVE_TESTIMONIALS'

const receiveTestimonials = (data) => ({ type: RECEIVE_TESTIMONIALS, data })

export const requestTestimonials = () => (dispatch) => {
    dispatch({ type: REQUEST_TESTIMONIALS })
    return axios
        .get('/testimonials', {
            baseURL: config.apiUrlWebsite,
        })
        .then((response) => {
            const responseData = response?.data || []
            dispatch(receiveTestimonials({ items: responseData }))
            return responseData
        })
        .catch(() => {})
}
